import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';
import AiUsageTabs from './AiUsageTabs';

const AiUsagePage = ({ currentUser }) => {
  const navigate = useNavigate();

  return (
    <Box>
      <Button
        size="small"
        startIcon={<BackIcon sx={{ fontSize: 16 }} />}
        onClick={() => navigate('/ai-assistant')}
        sx={{ fontSize: '0.8rem', textTransform: 'none', mb: 1.5 }}
      >
        Back to AI Assistant
      </Button>
      <AiUsageTabs currentUser={currentUser} />
    </Box>
  );
};

export default AiUsagePage;
